import React from 'react';
import { CtaButton } from './CtaButton';
import { IMAGES } from '../data/content';
const scattered = ['Courses', 'Notes', 'PDFs', 'Planning resources', 'Software', 'Protocols'];
export function AuthorSection() {
  return <section className="bg-white px-4 py-14 sm:px-6 sm:py-20" data-id="element-18" data-mp="177owjr9im18t">
      <div className="mx-auto w-full max-w-4xl" data-id="element-19" data-mp="1293vjpmfvdjb">
        <p className="text-center text-[10.5px] font-extrabold uppercase tracking-[0.2em] text-cta" data-id="element-20" data-mp="127ak7x0vs54z">
          Created by Dr. Karito
        </p>
        <h2 className="mt-4 text-center text-[24px] font-black leading-tight tracking-tight text-navy sm:text-4xl" data-id="element-21" data-mp="9lhg9k3umkgm">
          A practical system for dentists working with aligners
        </h2>

        <div className="mt-9 grid gap-7 md:grid-cols-[minmax(0,320px)_minmax(0,1fr)] md:items-start" data-id="element-22" data-mp="jicgc7frssx0">
          <figure className="mx-auto w-full max-w-[320px]" data-id="element-23" data-mp="3rxw3copulf3m">
            <img src={IMAGES.author} alt="Dr. Karito, creator of the Aligner Treatment Blueprint, in her dental clinic." className="w-full rounded-3xl object-cover shadow-xl shadow-navy/10" loading="lazy" data-id="element-24" data-mp="3rwcn2y46z41u" />
            <figcaption className="mt-3 text-center" data-id="element-25" data-mp="2znm938iodj94">
              <span className="block font-script text-2xl text-navy" data-id="element-26" data-mp="34fnjeowa8zwi">
                Dr. Karito
              </span>
              <span className="mt-0.5 block text-[11px] font-bold uppercase tracking-[0.16em] text-navy2/70" data-id="element-27" data-mp="39e75qqesgdpe">
                Creator of Aligner Treatment Blueprint™
              </span>
            </figcaption>
          </figure>

          <div data-id="element-28" data-mp="2gqusx7yfjk9a">
            <p className="text-[14.5px] leading-relaxed text-navy2 sm:text-base" data-id="element-29" data-mp="2gse96yk35vb2">
              After years of working with the realities of clinical practice,
              Dr. Karito recognized a common problem among professionals working
              with aligners: it wasn’t necessarily a lack of information.
            </p>

            <ul className="mt-5 flex flex-wrap gap-2" data-id="element-30" data-mp="5y0an8afvos8">
              {scattered.map(item => <li key={item} className="rounded-full border border-navy/10 bg-cream px-3 py-1.5 text-[12px] font-semibold text-navy2" data-id="element-31" data-mp="3cf8w5cyfop6w">
                  {item}
                </li>)}
            </ul>

            <p className="mt-5 text-[14.5px] leading-relaxed text-navy2 sm:text-base" data-id="element-32" data-mp="3mblqmd1sz72p">
              But there was often no simple way to organize all of that
              information around the individual case. That’s why ALIGNER
              TREATMENT BLUEPRINT™ was created — not as another long course, not
              as another theoretical ebook, but as a practical system of
              frameworks, planning maps, checklists, trackers, worksheets, and
              quick-reference tools designed to help organize the workflow
              surrounding aligner cases.
            </p>

            <p className="mt-6 text-[17px] font-black leading-snug text-navy sm:text-xl" data-id="element-33" data-mp="2awgb28gkpe1o">
              Less scattered information. More structure.
              <span className="block text-cta" data-id="element-34" data-mp="lgmchcmn956g">
                A clearer blueprint for every case.
              </span>
            </p>
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-md" data-id="element-35" data-mp="bjrgp1hr9ivv">
          <CtaButton label="Get the system created by Dr. Karito" subLabel="$27 one-time · Lifetime access · 7-day guarantee" data-id="element-36" data-mp="bl2kh1b7aqmz" />
        </div>
      </div>
    </section>;
}